// extracted by mini-css-extract-plugin
export default {"ArticleEdit":"jp_a bhk_qr bhk_a bhk_w bhk_ea","ArticleEdit__draft":"jp_b bhk_vt bhk_va bhk_so bhk_sm bhk_sn bhk_ru bhk_fg"};